import { FormattedMessage } from "react-intl";
import { displayPopin } from "../../Hook/popins";
import "./adsbanners.css";

function SubscriptionBanner() {
  const display = displayPopin();

  return (
    <button
      type="button"
      onClick={() => display("subscribe")}
      className="insite-ads-banner-card w-full max-w-[728px] rounded-2xl border border-white/40 bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#ec4899] px-6 py-4 text-left shadow-[0_18px_40px_rgba(124,58,237,0.4)] transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="insite-ads-banner-shine" />
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-white/80">
            <FormattedMessage id="ads_sub_kicker" defaultMessage="VIP access" />
          </p>
          <h3 className="text-2xl font-black text-white sm:text-3xl">
            <FormattedMessage
              id="ads_sub_title"
              defaultMessage="Unlock full subscriber perks"
            />
          </h3>
          <p className="text-sm text-white/90">
            <FormattedMessage
              id="ads_sub_body"
              defaultMessage="Get premium access and bonus features today."
            />
          </p>
        </div>
        <div className="mt-3 inline-flex items-center gap-2 self-start rounded-full bg-white px-5 py-2 text-sm font-bold text-[#7c3aed] shadow-sm sm:mt-0 sm:self-center">
          <FormattedMessage id="ads_sub_cta" defaultMessage="Go premium" />
          <span aria-hidden>→</span>
        </div>
      </div>
    </button>
  );
}

export default SubscriptionBanner;
